import { useLanguage } from "../i18n";
import type { CareProfile } from "../types";

/**
 * The owner's own care guide, rendered verbatim.
 *
 * These paragraphs stay Arabic in both language modes and are never
 * translated. Short labels around them switch; the instructions themselves do
 * not, because a paraphrase of "water when the first 3–4 cm dry out" is exactly
 * where a subtle error would creep into something that matters.
 */
export function CareGuide({ care }: { care: CareProfile }) {
  const { t, pick } = useLanguage();

  const paragraphs: Array<[string, string | null]> = [
    [t.watering, care.water_rule_ar],
    [t.soil, care.soil_ar],
    [t.pruning, care.pruning_ar],
    [t.warnings, care.warnings_ar],
  ];

  return (
    <section className="care-guide">
      <h2>{t.careGuide}</h2>

      {/* His own words, on their own surface. Never translated, in either
          language mode — a paraphrase of a care instruction is the one kind of
          error that actually harms a plant. */}
      <div className="care-body">
      <dl className="care-facts">
        {care.light && (
          <>
            <dt>{t.light}</dt>
            <dd>{pick(care.light)}</dd>
          </>
        )}
        {care.check_depth_cm !== null && (
          <>
            <dt>{t.checkDepth}</dt>
            <dd>
              {care.check_depth_cm} {t.cm}
            </dd>
          </>
        )}
      </dl>

      {paragraphs.map(([label, text]) =>
        text ? (
          <div className="care-para" key={label}>
            <h3>{label}</h3>
            {/* Always Arabic, always as written. */}
            <p lang="ar" dir="rtl">
              {text}
            </p>
          </div>
        ) : null,
      )}
      </div>
    </section>
  );
}
